import { Switch } from '@mui/material';
import { styled } from '@mui/material/styles';

const getOnColor = (color) => {
  switch (color) {
    case 'purple':
      return '#8953EF';
    case 'green':
      return '#1FCC92';
    default:
      return '#1FCC92';
  }
};

const StyledSwitch = styled(Switch, {
  shouldForwardProp: (prop) => prop !== 'oncolor' && prop !== 'enabletick',
})(({ theme, oncolor, enabletick, disabled }) => ({
  width: 47,
  height: 30,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: disabled ? '#BDBDBD' : getOnColor(oncolor),
        opacity: 1,
        border: 0,
      },
      '& .MuiSwitch-thumb:before': {
        backgroundImage: enabletick
          ? `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="12" width="12" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
              '#1FCC92'
            )}" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>')`
          : 'none',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 26,
    height: 26,
    boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.15)',
    '&:before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    },
  },
  '& .MuiSwitch-track': {
    borderRadius: 15,
    backgroundColor: disabled ? '#E5E5E5' : '#E5E5E5',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

const CustomSwitch = ({ onColor = 'green', enableTick = false, ...props }) => {
  return <StyledSwitch oncolor={onColor} enabletick={enableTick} {...props} />;
};

export default CustomSwitch;
